import type { CustomCellRendererProps } from "ag-grid-react";
import { Link } from "react-router-dom";
import { TruncateText } from "widgets";

import style from "../styles/Cell.module.css";

export const LinkExternalCell = (props: CustomCellRendererProps) => {
  const { label, link } = props.value ?? {};
  const labelText = String(label ?? "");

  return (
    <div className={style.cell}>
      <Link to={link} target="_blank" rel="noopener noreferrer" className={style.truncate_container}>
        <span className={style.truncate_autosize} aria-hidden>{labelText}</span>
        <TruncateText text={labelText} className={style.truncate_content} />
      </Link>
    </div>
  );
};
